import { ButtonProps, CSSObject } from '@chakra-ui/react';
import { TIndex } from '@/components/FormElements/Input';

export const PageHeader: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'semibold',
};

export const TextSubheading: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'normal',
};

export const Subheading: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'normal',
};

export const FormDivider: CSSObject = {
  borderBottom: '1px dashed',
  boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
  borderBottomColor: 'blackAlpha.400',
  width: '100%',
  borderTop: 'none',
  mb: '4',
};

export const DepositLimitGrid: CSSObject = {
  pb: '20',
};

export const ModalSubheading: CSSObject = {
  color: 'white',
  p: '0',
};

export const DepositButton: CSSObject = {
  borderRadius: 'md',
  bgGradient: 'linear(to-b, alpha.300 0%, alpha.700 100%)',
  color: 'alpha.900',
  fontFamily: 'accent',
  lineHeight: 'normal',
  fontWeight: 'normal',
  fontSize: 'sm',
  textTransform: 'capitalize',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.3)',
  boxShadow:
    '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.3) inset',
  _hover: {
    bgGradient: 'linear(to-b, alpha.300 0%, alpha.300 100%)',
  },
  ':active, &[data-active="true"]': {
    bg: 'blackAlpha.600',
    boxShadow:
      '0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
    color: 'alpha.400',
    textShadow: 'unset',
  },
  _disabled: {
    opacity: 0.4,
    '&&:hover': {
      bgGradient: 'linear(to-b, alpha.300 0%, alpha.700 100%)',
      color: 'alpha.900',
      opacity: 0.4,
    },
  },

  '&&&': {
    '& > svg, & > span': { zIndex: 9 },
  },
};

export const CancelButton: CSSObject = {
  variant: 'secondary',
};

export const ButtonSubmit: CSSObject = {
  variant: 'secondary',
};

export const DepositLimitContainer: CSSObject = {
  bg: 'white',
  fontFamily: 'body',
  borderRadius: 'md',
  p: '4',
  color: 'gray.600',
  fontWeight: '700',
  boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.3)',
  '.chakra-input__left-addon': {
    fontFamily: 'body',
  },
};

export const PendingLimitContainer: CSSObject = {
  border: 'none',
  fontWeight: '700',
  fontSize: 'xs',
};

export const LimitLabel: CSSObject = {
  fontSize: 'xs',
};

export const LimitValue: CSSObject = {
  fontWeight: 'medium',
  fontSize: 'xs',
};

export const ModalContentWrapper: CSSObject = {
  p: '0',
};

export const ModalDivider: CSSObject = {
  display: 'none',
};

export const buttonRemoveProps: CSSObject = {
  borderRadius: 'md',
  border: '2px solid',
  borderColor: 'alpha.300',
  color: 'blackAlpha.800',
  fontFamily: 'accent',
  fontSize: 'sm',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  bgGradient: 'linear(to-b, alpha.300, alpha.500)',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.25)',
  _hover: {
    bgGradient: 'linear(to-b, alpha.500, alpha.300)',
  },
  ':active, &[data-active="true"]': {
    color: 'beta.400',
    opacity: '0.8',
  },
  _disabled: {
    opacity: '0.4',
    pointerEvent: 'none',
  },

  '&&&': {
    '& > svg, & > span': { zIndex: 9 },
  },
};

export const buttonRemoveModalProps: ButtonProps = {
  variant: 'outline',
  fontWeight: 'normal',
  width: 'full',
};

export const buttonConfirmModalProps: ButtonProps = {
  variant: 'solid',
  fontWeight: 'normal',
  width: '50%',
};

export const inputProps: Partial<TIndex> = {
  sx: {
    '&&': {
      _placeholder: {
        color: 'white',
        textShadow: 'none',
      },
    },
  },
};

export const DepositLimitModalContentWrapper: CSSObject = {
  bg: 'blackAlpha.400',
  borderRadius: 'base',
  p: '4',
  color: 'white',
  fontWeight: '700',
};

export const DepositLimitInputContainer: CSSObject = {
  mb: '1',
  '#frequency-select': {
    bg: 'blackAlpha.400',
    boxShadow:
      '0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
    color: 'white',
    border: 'none',
    option: {
      color: 'white',
    },
  },
  '.chakra-select__wrapper': {
    svg: {
      color: 'white !important',
    },
  },
  '.chakra-input__group': {
    borderRadius: 'md',
    p: '1',
    bg: 'blackAlpha.600',
    border: 'none',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.13), 0px 3px 6px 0px rgba(0, 0, 0, 0.2) inset',
    ':has(#amount-input:focus)': {
      bg: 'blackAlpha.500',
      boxShadow:
        '0px 0px 6px 0px rgba(254, 196, 77, 0.6), 0px 0px 0px 2px #FEC44D inset',
    },
    ':has(#amount-input:hover)': {
      bg: 'blackAlpha.400',
      boxShadow:
        '0px 1px 0px 0px rgba(255, 255, 255, 0.13), 0px 3px 6px 0px rgba(0, 0, 0, 0.2) inset',
    },
    '#amount-input': {
      fontSize: 'sm',
      fontWeight: 'bold',
      borderLeft: 'none',
      borderLeftRadius: 'none',
      px: '2',
      h: '35px',
      fontFamily: 'accent',
      _placeholder: {
        fontWeight: 'bold',
      },
      _focus: {
        boxShadow: 'none',
        m: '0',
      },
    },
  },
  '.chakra-input__left-addon': {
    h: 'auto',
    w: '35px',
    border: 'none',
    fontWeight: 'bold',
    px: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  '.chakra-form__error-message': {
    bg: 'orange.300',
    boxShadow:
      '0px 2px 4px 0px rgba(0, 0, 0, 0.2), 0px 1px 0px 0px rgba(255, 255, 255, 0.2) inset',
    color: 'orange.800',
    h: '20px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '2xs',
    borderRadius: '3px',
    px: '8px',
    py: '4px',
    svg: {
      fontSize: 'sm',
    },
  },
  '.chakra-select__icon-wrapper': {
    color: 'beta.300',
  },
};
